module.exports = __webpack_public_path__ + "static/media/delete_link.266ba441.svg";